module.exports = __webpack_public_path__ + "img/Mega Central Finance.1e14758f.png";